// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface PinPaperIconSignature {
  Element: SVGSVGElement;
}

export const PinPaperIcon: TOC<PinPaperIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M12.101 2.10095L22 12L20.586 13.413L19.172 11.999L14.222 16.949L15.636 18.364L14.222 19.778L9.97899 15.536L4.32199 21.192L2.90799 19.778L8.56499 14.122L4.32199 9.87995L5.73599 8.46495L7.15099 9.87995V9.87895L12.102 4.92995V4.92895L10.687 3.51395L12.101 2.10095ZM12.808 15.536L12.809 15.535L17.757 10.586L13.515 6.34295L8.56599 11.293L12.808 15.536Z"/>
</svg>
</template>;